<template>
	<div class="mynavs">
		<div class="btn df hao" :class="{ cur: page==v.pagename }" @click="tapNav(v.page,v.pagename)" v-for="(v,i) in nav"><em :class="v.icon"></em>{{v.name}}<i v-if="v.type=='notice'&&$store.state.noticeNoread>0"></i></div>
	</div>
</template>

<script>
let clock = null
export default {
	name: 'mynavs',
	props: {
		page: {
			default: '',
		},
	},
	data () {
		return {
			nav: [
				{ name: '个人信息', page: 'my/info', pagename: 'my-info', icon: 'm1' },
				{ name: '认证绑定', page: 'my/account', pagename: 'my-account', icon: 'm2' },
				{ name: '账号安全', page: 'my/safe', pagename: 'my-safe', icon: 'm3' },
				{ name: '我的订单', page: 'my/order', pagename: 'my-order', icon: 'm4' },
				{ name: '消息中心', page: 'my/notice', pagename: 'my-notice', icon: 'm5', type: 'notice' },
			],
		}
	},
	methods: {
		tapNav(page,pagename){
			if(this.$route.name!=pagename){
				this.$api.toPage(page)
			}
		},
	},
}
</script>

<style lang="less" scoped>
	.mynavs{
		width: 192px;
		background: #ffffff;
		margin: 24px 16px 24px 0;
		position: sticky;
		top: 56px;
		.btn{
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 16px;
			color: #7F7F7F;
			line-height: 22px;
			padding: 16px 24px;
			min-height: 54px;
			position: relative;
			em{
				width: 20px;
				height: 20px;
				margin-right: 10px;
				background: url() center center / 100% auto no-repeat;
				&.m1{
					background-image: url(../../assets/img/my/1.png);
				}
				&.m2{
					background-image: url(../../assets/img/my/2.png);
				}
				&.m3{
					background-image: url(../../assets/img/my/3.png);
				}
				&.m4{
					background-image: url(../../assets/img/my/4.png);
				}
				&.m5{
					background-image: url(../../assets/img/my/5.png);
				}
			}
			i{
				width: 6px;
				height: 6px;
				background: #E73363;
				border-radius: 50%;
				position: absolute;
				left: 40px;
				top: 14px;
			}
			// &:hover{
			// 	color: #DA3B71;
			// }
			&.cur{
				color: #FFFFFF;
				background: #009b73;
				em{
					&.m1{
						background-image: url(../../assets/img/my/1h.png);
					}
					&.m2{
						background-image: url(../../assets/img/my/2h.png);
					}
					&.m3{
						background-image: url(../../assets/img/my/3h.png);
					}
					&.m4{
						background-image: url(../../assets/img/my/4h.png);
					}
					&.m5{
						background-image: url(../../assets/img/my/5h.png);
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/mynavs/mynavs.vue